<template>
  <div class="login-container">
    <div class="login-box">
      <h2>投票后台管理系统</h2>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading">登录</el-button>
        </el-form-item>
      </el-form>
<!--      <div class="icp-info">-->
<!--        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">蜀ICP备2025145558号</a>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import { adminLogin } from '@/api/admin'

export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loading: false,
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async handleLogin () {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            const res = await adminLogin(this.loginForm)
            this.$store.dispatch('login', {
              token: res.data.token,
              username: res.data.username || this.loginForm.username,
              name: res.data.name || res.data.username,
              userType: res.data.userType // 添加userType到store
            })
            this.$message.success('登录成功')
            this.$router.push('/home')
          } catch (error) {
            console.error('登录失败:', error)
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('https://bpic.588ku.com/back_origin_min_pic/23/06/29/93ec273e65bc5c0a221fe0b0b48d06f0.jpg!/fh/300/quality/90/unsharp/true/compress/true');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  padding: 20px;
}

.login-container::before {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  top: -50%;
  left: -50%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: moveBackground 20s linear infinite;
}

@keyframes moveBackground {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

.login-box {
  width: 100%;
  max-width: 400px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  position: relative;
  z-index: 1;
}

.login-box h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
  font-weight: 600;
}

.el-form-item {
  margin-bottom: 25px;
}

.el-form-item:last-child {
  text-align: center;
  margin-bottom: 0;
}

.el-form-item:last-child .el-button {
  width: 100%;
  max-width: 200px;
}

.icp-info {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: #909399;
}

.icp-info a {
  color: #909399;
  text-decoration: none;
}

.icp-info a:hover {
  color: #409EFF;
  text-decoration: underline;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .login-box {
    padding: 30px 20px;
  }

  .login-box h2 {
    font-size: 20px;
    margin-bottom: 25px;
  }
}

@media screen and (max-width: 480px) {
  .login-container {
    padding: 15px;
  }

  .login-box {
    padding: 25px 15px;
  }
}
</style>
